// extracted by mini-css-extract-plugin
module.exports = {"container":"License_container__-WAZR"};